export const COLORS = {
    prussianBlue: "#0A335C",
    primaryDeepSky:"#00ACFF",
    white:"#fff"
};

const palette ={
    primary: {
        light: COLORS.primaryDeepSky,
        main: COLORS.prussianBlue,
        contrastText: COLORS.white
    },
    divider:"#E6EBEF",
    background: {
        default: COLORS.white,
        paper: COLORS.white
    },
    action:{
        hover:"#F3F5F7",
    }
};


export default palette
